import { Link } from "react-router-dom";
import type { Character } from "@/types";
import Badge from "./Badge";

interface CharacterCardProps {
  character: Character;
}

export default function CharacterCard({ character }: CharacterCardProps) {
  return (
    <Link
      to={`/detail/${character.id}`}
      className="group flex cursor-pointer flex-col items-center overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 text-center transition-colors hover:border-primary-300"
    >
      <div className="mb-3 h-24 w-24 overflow-hidden rounded-full border-2 border-primary-200 bg-background-200 md:h-28 md:w-28">
        <img
          src={character.avatar}
          alt={`《${character.animeTitle}》角色 ${character.name}`}
          title={`${character.name} 角色介绍`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <h3 className="text-base font-bold text-foreground-950 group-hover:text-primary-700">
        {character.name}
      </h3>
      <p className="mt-0.5 text-xs text-foreground-500">《{character.animeTitle}》</p>
      <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
        {character.description}
      </p>
      <div className="mt-3 flex flex-wrap justify-center gap-1.5">
        <Badge tone="accent">{character.roleType}</Badge>
        {character.tags.slice(0, 1).map((tag) => (
          <Badge key={tag} tone="secondary">
            {tag}
          </Badge>
        ))}
      </div>
    </Link>
  );
}